function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: 86,
  y1: 31.22517,
  x2: 86,
  y2: 51.4495,
  gradientUnits: "userSpaceOnUse",
  id: "color-1_GokNRZdD1mWz_gr1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#21ad64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#088242"
})), /*#__PURE__*/React.createElement("radialGradient", {
  cx: -15.52658,
  cy: 41.80675,
  r: 242.59525,
  gradientUnits: "userSpaceOnUse",
  id: "color-2_GokNRZdD1mWz_gr2"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f44f5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.443,
  stopColor: "#ee3d4a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e52030"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: 86,
  y1: 51.95833,
  x2: 86,
  y2: 150.801,
  gradientUnits: "userSpaceOnUse",
  id: "color-3_GokNRZdD1mWz_gr3"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#21ad64"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#088242"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M0,172v-172h172v172z",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M86,21.5c-3.95958,0 -7.16667,1.60533 -7.16667,3.58333l3.58333,25.08333h7.16667l3.58333,-25.08333c0,-1.978 -3.20708,-3.58333 -7.16667,-3.58333z",
  fill: "url(#color-1_GokNRZdD1mWz_gr1)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.78467,43c-5.45742,0 -10.64608,0.41567 -15.34383,1.68775c-9.47075,2.5585 -19.41092,2.5585 -28.88525,0c-4.69417,-1.27208 -9.88283,-1.68775 -15.34383,-1.68775c-21.14883,0 -38.29508,25.3485 -38.29508,46.58333c0,9.47433 0,64.5 68.08333,64.5c68.08333,0 68.08333,-64.5 68.08333,-64.5c0,-21.23483 -17.14625,-46.58333 -38.29867,-46.58333z",
  fill: "url(#color-2_GokNRZdD1mWz_gr2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.62583,49.9875c-0.46583,-0.39417 -0.9675,-0.7525 -1.43333,-1.075c-0.50167,-0.35833 -1.00333,-0.68083 -1.505,-0.9675c-1.79167,2.54417 -6.3425,8.09833 -13.6525,11.03667c5.76917,10.39167 3.225,22.61083 3.225,22.61083c0,0 -11.9325,3.26083 -22.75417,-3.26083c-3.87,9.89 -12.50583,14.835 -12.50583,14.835c0,0 -8.42083,-5.51833 -12.3625,-14.90667c-10.8575,6.62917 -22.8975,3.3325 -22.8975,3.3325c0,0 -2.54417,-12.21917 3.225,-22.61083c-7.31,-2.93833 -11.86083,-8.4925 -13.6525,-11.03667c-0.50167,0.28667 -1.00333,0.60917 -1.505,0.9675c-0.46583,0.3225 -0.9675,0.68083 -1.43333,1.075c1.75583,2.4725 5.6975,7.27417 11.825,10.67833c-4.22833,10.46333 -2.07833,21.14167 -1.97083,21.64333l0.46583,2.15l2.11417,0.57333c0.14333,0.07167 3.51167,0.9675 8.2775,0.9675c4.98083,0 9.74667,-1.00333 13.975,-2.86667c4.6225,8.13417 11.64583,12.7925 11.96833,13.04333l1.8275,1.1825l1.935,-1.075c0.3225,-0.215 7.70417,-4.515 12.39833,-13.07917c4.15667,1.8275 8.85083,2.795 13.76,2.795c4.76583,0 8.09833,-0.89583 8.24167,-0.9675l2.11417,-0.57333l0.46583,-2.15c0.1075,-0.50167 2.2575,-11.18 -1.97083,-21.64333c6.1275,-3.40417 10.06917,-8.20583 11.825,-10.67833z",
  fill: "#000000",
  opacity: 0.05
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.1925,48.9125c-0.50167,-0.35833 -1.00333,-0.68083 -1.505,-0.9675c-1.79167,2.54417 -6.3425,8.09833 -13.6525,11.03667c5.76917,10.39167 3.225,22.61083 3.225,22.61083c0,0 -11.9325,3.26083 -22.75417,-3.26083c-3.87,9.89 -12.50583,14.835 -12.50583,14.835c0,0 -8.42083,-5.51833 -12.3625,-14.90667c-10.8575,6.62917 -22.8975,3.3325 -22.8975,3.3325c0,0 -2.54417,-12.21917 3.225,-22.61083c-7.31,-2.93833 -11.86083,-8.4925 -13.6525,-11.03667c-0.50167,0.28667 -1.00333,0.60917 -1.505,0.9675c1.72,2.50833 5.94833,7.70417 12.685,10.92917c-4.87333,10.4275 -2.61583,21.6075 -2.50833,22.10917l0.215,1.075l1.075,0.28667c0.1075,0.03583 3.26083,0.89583 7.81167,0.89583c5.33917,0 10.39167,-1.1825 14.7275,-3.44c4.33583,8.67167 11.86083,13.68833 12.21917,13.90333l0.89583,0.60917l0.9675,-0.57333c0.35833,-0.17917 8.17,-4.73 12.47,-13.8675c5.375,2.75917 10.82167,3.36833 14.58417,3.36833c4.515,0 7.66833,-0.86 7.77583,-0.89583l1.075,-0.28667l0.215,-1.075c0.1075,-0.50167 2.365,-11.68167 -2.50833,-22.10917c6.73667,-3.225 10.965,-8.42083 12.685,-10.92917z",
  fill: "#000000",
  opacity: 0.07
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.58333,46.58333c0,0 -0.28667,0.50167 -0.89583,1.36167c-1.79167,2.54417 -6.3425,8.09833 -13.6525,11.03667c5.76917,10.39167 3.225,22.61083 3.225,22.61083c0,0 -11.9325,3.26083 -22.75417,-3.26083c-3.87,9.89 -12.50583,14.835 -12.50583,14.835c0,0 -8.42083,-5.51833 -12.3625,-14.90667c-10.8575,6.62917 -22.8975,3.3325 -22.8975,3.3325c0,0 -2.54417,-12.21917 3.225,-22.61083c-7.31,-2.93833 -11.86083,-8.4925 -13.6525,-11.03667c-0.60917,-0.86 -0.89583,-1.36167 -0.89583,-1.36167c0,0 9.31667,-14.33333 24.47417,-14.33333c15.12167,0 22.10917,14.33333 22.10917,14.33333c0,0 6.9875,-14.33333 22.10917,-14.33333c15.1575,0 24.47417,14.33333 24.47417,14.33333z",
  fill: "url(#color-3_GokNRZdD1mWz_gr3)"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 48,
    height: 48,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _ref3, _ref4));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c70eb15cbdd87e5b04ae4c9e851511a3.svg";
export { ForwardRef as ReactComponent };